/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
// import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { useLoader } from '../../context/LoaderContext'

const DashboardPage = (props) => (
  <>
    <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      {/* Total Patients */}
      <div className='col-xl-6'>
        <div className='card card-xl-stretch mb-xl-10 theme-dark-bg-body shadow'>
          <div className='card-body d-flex flex-column'>
            <div className='d-flex flex-column flex-grow-1'>
              <Link
                to='/manage-user/patients'
                className='text-dark text-hover-primary fw-bolder fs-3 mb-4'
              >
                Total Registered Patients
              </Link>
              <div className='mt-5'>
                <span className='text-primary fw-bolder fs-3x me-2 lh-0'>
                  {props.stats?.totalPatients || 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Total Doctors */}
      <div className='col-xl-6'>
        <div className='card card-xl-stretch mb-xl-10 theme-dark-bg-body shadow'>
          <div className='card-body d-flex flex-column'>
            <div className='d-flex flex-column flex-grow-1'>
              <Link
                //! ADD link later
                to='/manage-user/professionals'
                className='text-dark text-hover-primary fw-bolder fs-3 mb-4'
              >
                Total Professionals
              </Link>
              <div className='mt-5'>
                <span className='text-dark fw-bolder fs-3x me-2 lh-0'>
                  {props.stats?.totalProfessionals || 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* </div> */}
    <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      {/* Total Appointments */}
      <div className='col-xl-6 mt-3'>
        <div className='card card-xl-stretch mb-xl-10 theme-dark-bg-body shadow'>
          <div className='card-body d-flex flex-column'>
            <div className='d-flex flex-column flex-grow-1'>
              <Link
                to='/appointment'
                className='text-dark text-hover-primary fw-bolder fs-3 mb-4'
              >
                Total Appointments
              </Link>
              <div className='mt-5'>
                <span className='text-success fw-bolder fs-3x me-2 lh-0'>
                  {props.stats?.totalAppointments || 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Total Upcomming Appointments */}
      <div className='col-xl-6 mt-3'>
        <div className='card card-xl-stretch mb-xl-10 theme-dark-bg-body shadow'>
          <div className='card-body d-flex flex-column'>
            <div className='d-flex flex-column flex-grow-1'>
              <Link
                to='/appointment'
                className='text-dark text-hover-primary fw-bolder fs-3 mb-4'
              >
                Total Upcomming Appointments
              </Link>
              <div className='mt-5'>
                <span className='text-warning  fw-bolder fs-3x me-2 lh-0'>
                  {props.stats?.totalUpcommingAppointments || 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      {/* Total Services */}
      <div className='col-xl-6 mt-3'>
        <div className='card card-xl-stretch mb-xl-10 theme-dark-bg-body shadow'>
          <div className='card-body d-flex flex-column'>
            <div className='d-flex flex-column flex-grow-1'>
              <Link
                to='/services'
                className='text-dark text-hover-primary fw-bolder fs-3 mb-4'
              >
                Total Services
              </Link>
              <div className='mt-5'>
                <span className='text-info fw-bolder fs-3x me-2 lh-0'>
                  {props.stats?.totalServices || 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Total Packages */}
      <div className='col-xl-6 mt-3'>
        <div className='card card-xl-stretch mb-xl-10 theme-dark-bg-body shadow'>
          <div className='card-body d-flex flex-column'>
            <div className='d-flex flex-column flex-grow-1'>
              <Link
                to='/products'
                className='text-dark text-hover-primary fw-bolder fs-3 mb-4'
              >
                Total Packages
              </Link>
              <div className='mt-5'>
                <span className='text-danger fw-bolder fs-3x me-2 lh-0'>
                  {props.stats?.totalProducts || 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
)

const DashboardWrapper = () => {
  const intl = useIntl()

  const { showLoader, closeLoader } = useLoader()

  const [stats, setStats] = useState({})

  useEffect(() => {
    const token = localStorage.getItem('kt-auth-react-v.api_token')
    showLoader()
    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/dashboard-stats`, {
        headers: { Authorization: ` ${token}` },
      })
      .then((res) => {
        setStats(res.data.result)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        closeLoader()
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      </PageTitle>
      <DashboardPage stats={stats} />
    </>
  )
}

export { DashboardWrapper }
